import client from "./client";

export default {
    async getPropertiesSummary(filters) {
        return client.parseResponse(await client.get('/settlements/properties', filters));
    },
    async getPropertiesSummaryDashboard(filters) {
        return client.parseResponse(await client.get('/properties-summary', filters));
    },

    async previewSettlement(data) {
        return client.parseResponse(await client.post('/settlements/preview', data));
    },

    async requestSettlementOtp(data) {
        return client.parseResponse(await client.post('/settlements/request-otp', data));
    },

    async confirmSettlement(data) {
        return client.parseResponse(await client.post('/settlements', data));
    },

    async getSettlements(filters) {
        return client.parseResponse(await client.get('/settlements', filters));
    },
}
